Namespace 'Common.Sessions'

class Common.Sessions.EmptySessionView extends Backbone.View
  template: JST['backbone/templates/common/sessions/empty_session']
  id: 'empty-session'

  initialize: ({session, sessions}) ->
    @session = session
    @sessions = sessions
    @newSessionModal = new Common.Sessions.NewSessionModalView()
    @sessionListView = new Common.Sessions.ListView(sessions: @sessions)
    @listenTo(@newSessionModal, 'session:create', @createNewSession)
    @

  render: =>
    @$el.html(@template())
    @renderNewSessionModal()
    @renderSessionList()
    @

  renderNewSessionModal: ->
    @$('#new-session-container').empty().append(@newSessionModal.render().el)

  renderSessionList: (sessions) ->
    @$('#session-list').empty().append(@sessionListView.render().el)

  createNewSession: ->
    name = moment().format('DD-MM-YYYY HH:mm:ss')
    @session.set('name', name)
    @sessions.saveSelectedSession()

  shouldRerender: ->
    true
